import { Directive, ElementRef, HostListener, inject, input } from '@angular/core';
import { concat, interval, Subscription } from 'rxjs';
import { take } from 'rxjs/operators';

@Directive({
  selector: '[libAutoclicker]',
})
export class AutoclickerDirective {
  private readonly el = inject(ElementRef<HTMLElement>);

  readonly appAutoclicker = input<number>(100);

  readonly appAutoclickerCutoff = input<number>(700);

  private subscription: Subscription | null = null;

  @HostListener('mousedown') onMouseDown(): void {
    this.startClicks();
  }

  @HostListener('mouseup') onMouseUp(): void {
    this.stopClicks();
  }

  @HostListener('mouseout') onMouseOut(): void {
    this.stopClicks();
  }

  @HostListener('touchstart') onTouchStart(): void {
    this.startClicks();
  }

  @HostListener('touchend') onTouchEnd(): void {
    this.stopClicks();
  }

  @HostListener('touchcancel') onTouchCancel(): void {
    this.stopClicks();
  }

  private startClicks(): void {
    if (this.subscription) {
      return;
    }

    this.raiseEvent();

    this.subscription = concat(
      interval(this.appAutoclickerCutoff()).pipe(take(1)),
      interval(this.appAutoclicker()),
    ).subscribe(() => {
      this.raiseEvent();
    });
  }

  private stopClicks(): void {
    if (!this.subscription) {
      return;
    }

    this.subscription.unsubscribe();
    this.subscription = null;
  }

  private raiseEvent(): void {
    this.el.nativeElement.dispatchEvent(new Event('autoclick'));
  }
}
